import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Title from '../components/header/Title'
import ProductWizard from '../components/product/ProductWizard'

const AddProduct: React.FC = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const isEditMode = Number(id) > 0;

    return (
        <React.Fragment>
            <Title
                title={isEditMode ? "Edit Product" : "Add Product"}
                subtitle={isEditMode ? "Update Product Details" : "Create a New Product"}
                onBack={() => navigate('/products')}
            />
            <ProductWizard />
        </React.Fragment>
    )
}

export default AddProduct
